<style scoped>
.table-icons {
  float: right;
}
</style>

<template>
  <div>
    <div class="block table-icons">
      <b-tooltip
        @click.native="aanpassen()"
        v-if="selected"
        label="Leverdag bekijken"
        position="is-top"
      >
        <span class="pointer table-icon">
          <b-icon icon="search"></b-icon>
        </span>
      </b-tooltip>
    </div>
    <br />
    <b-table
      :data="index"
      :bordered="true"
      :striped="true"
      :hoverable="true"
      :loading="ajaxloading.get_index"
      :focusable="false"
      :mobile-cards="false"
      :selected.sync="selected"
      @dblclick="aanpassen()"
      detailed
      detail-key="id"
    >
      <b-table-column field="id" label="ID" width="40" numeric v-slot="props">
        {{ props.row.id }}
      </b-table-column>

      <b-table-column field="name" label="Bestellingsdag" v-slot="props">
        {{ formatDatePickerDate(props.row.bestellingsdag) }}
      </b-table-column>

      <b-table-column field="name" label="Inschrijving geopend" v-slot="props">
        <span v-if="props.row.inschrijving_geopend">
          <b-icon style="color: green" icon="check" size="is-small"> </b-icon>
        </span>
        <span v-if="!props.row.inschrijving_geopend">
          <b-icon style="color: red" icon="times" size="is-small"> </b-icon>
        </span>
      </b-table-column>

      <b-table-column field="name" label="Zichtbaar" v-slot="props">
        <span v-if="props.row.zichtbaar">
          <b-icon style="color: green" icon="check" size="is-small"> </b-icon>
        </span>
        <span v-if="!props.row.zichtbaar">
          <b-icon style="color: red" icon="times" size="is-small"> </b-icon>
        </span>
      </b-table-column>

      <b-table-column field="name" label="Bestellingen" v-slot="props">
        {{ props.row.bestellingen }}
      </b-table-column>

      <b-table-column field="name" label="Totale producten" v-slot="props">
        {{ props.row.totale_producten }}
      </b-table-column>

      <b-table-column field="name" label="Bestelde producten" v-slot="props">
        {{ props.row.bestelde_producten }}
      </b-table-column>

      <b-table-column field="name" label="Beschikbare producten" v-slot="props">
        {{ props.row.totale_producten - props.row.bestelde_producten }}
      </b-table-column>

      <template #detail="props">
        <div class="columns">
          <div class="column is-3">Registratie open:</div>
          <div class="column">
            {{
              formatDatePickerDateAndTime(
                props.row.bestelling_openings_timestamp
              )
            }}
          </div>
        </div>
        <div class="columns">
          <div class="column is-3">Registratie sluiting:</div>
          <div class="column">
            {{
              formatDatePickerDateAndTime(
                props.row.bestelling_sluitings_timestamp
              )
            }}
          </div>
        </div>
        <div class="columns">
          <div class="column is-3">Bestelling zichtbaar:</div>
          <div class="column">
            {{
              formatDatePickerDateAndTime(
                props.row.bestelling_zichtbaar_timestamp
              )
            }}
          </div>
        </div>
        <div class="columns">
          <div class="column is-3">Bestelling onzichtbaar:</div>
          <div class="column">
            {{
              formatDatePickerDateAndTime(
                props.row.bestelling_onzichtbaar_timestamp
              )
            }}
          </div>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    index: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {},
  methods: {
    toevoegen() {
      this.$router.push({ name: "bestellingsdag-toevoegen" });
    },
    aanpassen() {
      this.$router.push({
        name: "leverdag-bekijken",
        params: { leverdag: this.selected.id },
      });
    },
  },
  mounted() {},
};
</script>
